module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Sturz ro.0ac5eda5.svg";